import { useEffect, useRef } from 'react';
import { advanceKonami, shouldIgnoreKonamiTarget } from '../utils/easterEggs';

/** Lauscht nur, solange die Komponente montiert ist. Tastendrücke in Feldern zählen nicht. */
export function useKonamiCode(onMatch: () => void): void {
  const onMatchRef = useRef(onMatch);
  onMatchRef.current = onMatch;

  useEffect(() => {
    let index = 0;
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.metaKey || event.ctrlKey || event.altKey) return;
      if (shouldIgnoreKonamiTarget(event.target)) {
        index = 0;
        return;
      }
      const step = advanceKonami(index, event.key);
      index = step.index;
      if (step.matched) {
        onMatchRef.current();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);
}
